export const WORKFLOW_WIDGET_RENDERING_TYPES = {
  SCREEN: 'SCREEN',
  SCREEN_COMPONENT: 'SCREEN_COMPONENT',
};

export const WORKFLOW_WIDGET_RENDERING_TYPE_OPTIONS = [
  { label: 'Screen', value: WORKFLOW_WIDGET_RENDERING_TYPES.SCREEN },
  { label: 'Screen Component', value: WORKFLOW_WIDGET_RENDERING_TYPES.SCREEN_COMPONENT },
];
